import { render } from "./themeOrderAdd.vue?vue&type=template&id=3be0b2c9"
import script from "./themeOrderAdd.vue?vue&type=script&lang=js"
export * from "./themeOrderAdd.vue?vue&type=script&lang=js"

import "./themeOrderAdd.vue?vue&type=style&index=0&id=3be0b2c9&lang=css"

import exportComponent from "D:\\Program Files\\vueProject\\sys-bg-sjyy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__